import PropTypes from 'prop-types';
import { useState } from 'react';
import {
    Avatar,
    Box,
    Button,
    IconButton,
    Stack,
    TextField,
    Typography
} from '@mui/material';
import Iconify from 'src/components/iconify';

export default function TaskActivity({ comments, onAddComment, memberOptions }) {
    const [ commentText, setCommentText ] = useState('');

    const handleAdd = () => {
        if (!commentText.trim()) return;

        const newComment = {
            id: Date.now(),
            author: 'You',
            author_id: 'BA', // Assuming current user
            content: commentText,
            time: 'Just now',
            date: new Date().toLocaleString()
        };

        onAddComment(newComment);
        setCommentText('');
    };

    return (
        <Box sx={ { mb: 3 } }>
            <Stack direction="row" justifyContent="space-between" sx={ { mb: 1 } }>
                <Typography variant="subtitle1">Activity</Typography>
                <Button size="small">Hide details</Button>
            </Stack>

            <Stack spacing={ 2 } sx={ { mt: 1 } }>
                <Stack direction="row" spacing={ 2 }>
                    <Avatar sx={ { bgcolor: '#1976d2', width: 30, height: 30, fontSize: 14 } }>BA</Avatar>
                    <TextField
                        fullWidth
                        placeholder="Write a comment..."
                        multiline
                        minRows={ 1 }
                        value={ commentText }
                        onChange={ (e) => setCommentText(e.target.value) }
                        InputProps={ {
                            endAdornment: (
                                <IconButton onClick={ handleAdd }>
                                    <Iconify icon="mdi:send" />
                                </IconButton>
                            ),
                        } }
                    />
                </Stack>

                { comments.map((comment, index) => (
                    <Stack key={ index } direction="row" spacing={ 2 }>
                        <Avatar
                            sx={ {
                                bgcolor: memberOptions.find(m => m.id === comment.author_id)?.color || '#1976d2',
                                width: 30,
                                height: 30,
                                fontSize: 14
                            } }
                        >
                            { comment.author_id || comment.author.charAt(0) + comment.author.split(' ')[ 1 ]?.charAt(0) }
                        </Avatar>
                        <Box>
                            { comment.content ? (
                                <Stack direction="row" spacing={ 1 } alignItems="center">
                                    <Typography variant="subtitle2">{ comment.author }</Typography>
                                    <Typography variant="body2">{ comment.content }</Typography>
                                </Stack>
                            ) : (
                                <Stack direction="row" spacing={ 0.5 } alignItems="center" flexWrap="wrap">
                                    <Typography variant="subtitle2">{ comment.author }</Typography>
                                    { comment.action && <Typography variant="caption">{ comment.action }</Typography> }
                                    { comment.attachment && (
                                        <Typography variant="caption" color="primary.main">
                                            { comment.attachment }
                                        </Typography>
                                    ) }
                                    { comment.target && <Typography variant="caption">{ comment.target }</Typography> }
                                </Stack>
                            ) }
                            <Typography variant="caption" color="text.secondary">
                                { comment.time || comment.date }
                            </Typography>
                            { comment.content && (
                                <Box sx={ { mt: 1 } }>
                                    <Button size="small" variant="text" sx={ { minWidth: 'auto', p: 0, mr: 1 } }>
                                        Reply
                                    </Button>
                                </Box>
                            ) }
                        </Box>
                    </Stack>
                )) }
            </Stack>
        </Box>
    );
}

TaskActivity.propTypes = {
    comments: PropTypes.array.isRequired,
    onAddComment: PropTypes.func.isRequired,
    memberOptions: PropTypes.array.isRequired
};
